export default "__VITE_ASSET__C4itS8Xa__"